import {
  createRouter,
  createWebHistory,
  type RouteRecordRaw,
} from 'vue-router';

import TheHeader from '@/components/home-header/TheHeader.vue';
import { setShareConfig, type Config } from '@/utils/share';
import { setDefaultShareConfig } from '@/utils/tools';
import { useShenCe } from '@/utils/shence';

const { track } = useShenCe();

// 自动加载模块路由
function autoImport() {
  const files: Record<string, { default: RouteRecordRaw[] }> = import.meta.glob(
    './modules/*.ts',
    { eager: true }
  );
  const routes: RouteRecordRaw[] = [];
  Object.keys(files).forEach((key) => {
    const file = files[key].default || {};
    const fileArray = Array.isArray(file) ? [...file] : [file];
    routes.push(...fileArray);
  });
  return routes;
}
const importRoutes = autoImport();
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      component: TheHeader,
      redirect: '/headline',
      children: [
        {
          path: '/headline', // 头条
          name: 'headline',
          meta: {
            title: '科普中国Lite',
          },
          component: () => import('@/views/headline/HeadlineHome.vue'),
        },
        {
          path: '/interest', // 关注
          name: 'interest',
          meta: {
            title: '科普中国Lite',
          },
          component: () => import('@/views/interest/InterestPage.vue'),
        },
        {
          path: '/clienthome', // 我的
          name: 'clienthome',
          meta: {
            title: '科普中国Lite',
          },
          component: () => import('@/views/client/ClientHome.vue'),
        },
        {
          path: '/ai/index',
          name: 'ai-index',
          component: () => import('@/views/ai/AIIndex.vue'),
          meta: {
            title: '科普中国Lite',
          },
        },
        {
          path: '/channel/home',
          name: 'channel-home',
          component: () => import('@/views/localchannel/ChannelHome.vue'),
          meta: {
            title: '科普中国Lite',
          },
        },
        {
          path: '/recommendation', // 推荐
          name: 'recommendation',
          meta: {
            title: '科普中国Lite',
          },
          component: () =>
            import('@/views/recommendation/RecommendationList.vue'),
        },
      ],
    },
    {
      path: '/tuwendetail', // 图文详情
      name: 'tuwendetail',
      meta: {
        title: '图文详情',
      },
      component: () => import('@/views/details/TuWenDetail.vue'),
    },
    {
      path: '/videodetail', // 视频详情
      name: 'videodetail',
      meta: {
        title: '视频详情',
      },
      component: () => import('@/views/details/VideoDetail.vue'),
    },
    {
      path: '/viewreplies', // 回复评论列表
      name: 'viewreplies',
      meta: {
        title: '回复评论',
      },
      component: () => import('@/views/details/ViewReplies.vue'),
    },
    {
      path: '/kphpage', //科普号主页
      name: 'kphpage',
      meta: {
        title: '科普号主页',
      },
      component: () => import('@/views/kph-home/KphPage.vue'),
    },
    {
      path: '/ztlist', // 专题列表
      name: 'ztlist',
      meta: {
        title: '精彩专题',
      },
      component: () => import('@/views/zt-list/SubjectIndex.vue'),
    },
    {
      path: '/ztdetail', //
      name: 'ztdetail',
      meta: {
        title: '专题详情',
      },
      component: () => import('@/views/zt-list/SubjectDetails.vue'),
    },
    {
      path: '/login', //登录
      name: 'login',
      meta: {
        title: '登录',
      },
      component: () => import('@/views/login/UserLogin.vue'),
    },
    {
      path: '/register', //注册
      name: 'register',
      meta: {
        title: '注册',
      },
      component: () => import('@/views/login/UserRegister.vue'),
    },
    {
      path: '/forget-password', //修改密码
      name: 'forget-password',
      meta: {
        title: '找回密码',
      },
      component: () => import('@/views/login/ForgetPassword.vue'),
    },
    {
      path: '/applypersonnel', //申请科普员
      name: 'applypersonnel',
      meta: {
        title: '申请科普员',
      },
      component: () => import('@/views/kp-personnel/ApplyPersonnel.vue'),
    },
    {
      path: '/passexamine',
      name: 'passexamine', // 科普员用户信息审核
      meta: {
        title: '科普员用户信息审核',
      },
      component: () => import('@/views/examine/PassExamine.vue'),
    },
    {
      path: '/overviewpersonnel',
      name: 'overviewpersonnel', // 科普员概况只有个人信息
      meta: {
        title: '科普员概况',
      },
      component: () => import('@/views/kp-personnel/OverviewPersonnel.vue'),
    },
    {
      path: '/activity/detail',
      name: 'activity-details', // 活动详情
      meta: {
        title: '活动详情',
      },
      component: () => import('@/views/activity/DetailPages.vue'),
    },
    {
      path: '/activity/pctips',
      name: 'activity-pctips', // PC端活动发布
      meta: {
        title: 'PC端活动发布',
      },
      component: () => import('@/views/activity/PctipsPage.vue'),
    },
    {
      path: '/activity/daka',
      name: 'activity-daka', // 打卡详情
      meta: {
        title: '打卡详情',
      },
      component: () => import('@/views/activity/DakaPage.vue'),
    },
    {
      path: '/activity/manage/detail',
      name: 'activity-manage-detail', // app内部编辑普通活动详情
      meta: {
        title: '活动详情',
        hideShare: true,
      },
      component: () => import('@/views/activity/manage/DetailPage.vue'),
    },
    {
      path: '/overviewpersonnel-home',
      name: 'overviewpersonnel-home', // 科普员概况个人信息加该机构成员发布的信息
      meta: {
        title: '科普员概况',
      },
      component: () => import('@/views/kp-personnel/OverviewPersonnelPage.vue'),
    },
    {
      path: '/activity/detail/base',
      name: 'activity-detail-base', // app内部编辑普通活动详情
      meta: {
        title: '科普教育基地详情',
      },
      component: () => import('@/views/activity/BasePages.vue'),
    },
    {
      path: '/activity/basedaka',
      name: 'activity-basedaka', // 打卡详情
      meta: {
        title: '科普教育基地打卡详情',
      },
      component: () => import('@/views/activity/BaseDakaDetail.vue'),
    },
    {
      path: '/channel/morezt',
      name: 'channel-morezt',
      component: () => import('@/views/localchannel/MoreListZt.vue'),
      meta: {
        title: '专题推荐',
      },
    },
    {
      path: '/channel/moreact',
      name: 'channel-moreact',
      component: () => import('@/views/localchannel/MoreListAct.vue'),
      meta: {
        title: '精彩活动',
      },
    },
    {
      path: '/sciencedaily', // 头条
      name: 'sciencedaily',
      meta: {
        title: '科普日报',
      },
      component: () => import('@/views/headline/ScienceDailyDetail.vue'),
    },
    ...importRoutes,
    // 404 页面 - 必须放在最后
    {
      path: '/:pathMatch(.*)*',
      name: 'not-found',
      meta: {
        title: '页面不存在',
      },
      component: () => import('@/views/NotFound.vue'),
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
});
router.beforeEach(async (to) => {
  track('M_KepuchinaPageView');
  if (to.meta.title) {
    // 判断是否有标题
    document.title = to.meta.title as string;
  }
  if (!to.meta.hideShare) {
    // 路由 meta 配置了 share 时优先使用（活动页等），否则用默认分享
    if (to.meta.share) {
      setShareConfig(to.meta.share as Config);
    } else {
      setDefaultShareConfig();
    }
  }
});
export default router;
